import React from "react"
import Navbar from "../bootstrap/navbar"
import Nav from "../bootstrap/nav"
import NavItem from "../bootstrap/nav_item"
import Container from "../bootstrap/container"
import { Link } from "gatsby"
//import Config from "../../../gatsby-config"
import { useStaticQuery, graphql } from "gatsby"
import DmaeLogo from "./sub-nav-dmae"
import Social from "./sub-nav-social"

export default function SubNavStudent(projectActive) {
  const styleLink = `${projectActive?.projectActive ? 'active ': ''}nav-link px-2}`
  // need to override nav-link font settings
  const textStyles = {
    fontSize: '0.9rem',
    fontWeight: 500,
  }
  const data = useStaticQuery(graphql`
    query SubNavStudentQuery {
      allDirectory(
        filter: {
          sourceInstanceName: { eq: "posts" }
          relativeDirectory: { eq: "projects" }
        }
        sort: { base: DESC }
        limit: 1
      ) {
        edges {
          node {
            base
          }
        }
      }
    }
  `)
  return (
    <Navbar id="nav-sub" bg="lsu-light-purple" variant="dark" expand={true}>
      <Container>
        <DmaeLogo />
        <div className="d-flex">
          <Nav as="ul">
            <NavItem as="li">
              <Link
                to="/master-class-schedule/"
                className={`nav-link px-2`}
                style={textStyles}
                activeClassName="active"
              >
                <span className="d-none d-md-block">Master Class Schedule</span>

                <span className="d-block d-md-none">Sched</span>
              </Link>
            </NavItem>

            <NavItem as="li">
              <Link
                to={`/projects/projects${data.allDirectory.edges[0].node.base}/`}
                className={styleLink}
                style={textStyles}
                activeClassName="active"
              >
                Projects
              </Link>
            </NavItem>

            <NavItem as="li" className="me-4">
              <Link
                to="/lab-faq/"
                className={`nav-link px-2`}
                style={textStyles}
                activeClassName="active"
              >
                Lab FAQ
              </Link>
            </NavItem>
          </Nav>
          <Social />
        </div>
      </Container>
    </Navbar>
  )
}
